import { useCallback, useState } from 'react'
import LoaderDecider from '../../../../../../../baseComponents/LoaderDecider'
import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import VerticalSortList from '../../../../../../../baseComponents/Sorts/VerticalSortList'
import { VerticalSortItem } from '../../../../../../../baseComponents/Sorts/VerticalSortList/types'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import Checkbox from '../../../../../../../forms/Checkbox'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { changeEmployeeParams } from '../../../../../../../utils/reducers/reduxDispatch'
import { TaskCFieldModelType } from '@teinor/erp/types/company/task/taskCField'

interface TaskCFieldTypeModelTypeExt extends TaskCFieldModelType {
    checked?: boolean
    order: number
}

type ModalTaskCFieldsFlowProps = ModalTaskCFieldsFlowLogicProps & {
}

const ModalTaskCFieldsFlow: React.FC<ModalTaskCFieldsFlowProps> = ({ TaskCFieldsTypes, ...rest }) => {
    const { t } = useTwinTranslation()
    const { data, changeChecked, changeOrder, beforeSubmit } = useModalTaskCFieldsFlowLogic({ TaskCFieldsTypes, ...rest})
    const secondColumn: VerticalSortItem[] = []
    const renderThis: JSX.Element[] = []

    for (const key in data) {
        const item = data[key]
        renderThis.push(
            <div key={key}>
                <Checkbox label={item.name} onChange={() => changeChecked(parseInt(key))} checked={item.checked}></Checkbox>
            </div>
        )
        if (item.checked) {
            secondColumn.push({
                name: item.name,
                id: JSON.stringify(item.id),
                order: item.order
            })
        }
    }
    secondColumn.sort((a, b) => a.order - b.order)
    
    return (
        <ModalCreateEdit fields={[]} url={''} translations={{
            title: t('configureFavorites', 'Configurar favoritos'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} beforeSubmit={() => { beforeSubmit(); return false }} {...rest}>
            <div className='overflow-auto h-full w-full'>
                <div className='flex flex-wrap w-full h-full config_columns_container'>
                    <div className='flex  flex-col'>
                        <h4 className='mr-18 mb-20 '><TwinTrans transKey='selectYourFavoriteTaskCustomFields'>Selecciona tus campos favoritos</TwinTrans></h4>
                        {renderThis}
                    </div>
                    <div className='border-r border-gray-D6 w-1 mx-75 config_columns_border'></div>
                    <div className='flex flex-col min-h-full flex-auto w-1 config_colums_sort_list'>
                        <LoaderDecider loading={data === null}>
                            <h4 className='mb-20'><TwinTrans transKey='orderYourFavoriteTaskCustomFields'>Ordena tus campos favoritos</TwinTrans></h4>
                            {data !== null && <VerticalSortList items={secondColumn} setItems={(setItemsFake) => changeOrder(setItemsFake(secondColumn))}></VerticalSortList>}
                        </LoaderDecider>
                    </div>
                </div>
            </div>
        </ModalCreateEdit>
    )
}

interface ModalTaskCFieldsFlowLogicProps extends ModalEditComponentProps {
    TaskCFieldsTypes: TaskCFieldTypeModelTypeExt[]
    onSubmit: OnSubmit
}
const useModalTaskCFieldsFlowLogic = ({ TaskCFieldsTypes, onSubmit, setOpened }: ModalTaskCFieldsFlowLogicProps) => {
    const [data, setData] = useState(TaskCFieldsTypes)
    const changeChecked = useCallback( async(key: number) => {
        setData((old) => {
            if (!old) {
                return old
            }
            const copy = JSON.parse(JSON.stringify(old))
            if (copy[key].checked === undefined) {
                copy[key].checked = true
            } else {
                copy[key].checked = !copy[key].checked 
            }
            let order =1
            for (const element of copy) {
                if (element.checked) {
                    element.order = order
                    order++
                }
            }
            return copy
        })
    }, [setData])
    
    const changeOrder = useCallback((items: VerticalSortItem[]) => {
        setData((old) => {
            if (!old) {
                return old
            }
            const copy = JSON.parse(JSON.stringify(old))
            const myOrder: TwinDictionary= {}
            for (let i = 0; i < items.length; i++) {
                const id = parseInt(items[i].id) 
                myOrder[id] = i +1
            }
            for (const item of copy) {
                if (myOrder[item.id]) {
                    item.order = myOrder[item.id]
                }
            }
            return copy
        })
    }, [setData])

    const beforeSubmit = useCallback(async () => {
        const dataToUpdate: TwinDictionary = {}
        for (const item of data) {
            if (item.checked) {
                dataToUpdate[item.id] = item.order
            }
        }
        const myDataToUpdate = JSON.stringify(dataToUpdate)
        const result = await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'task_board_custom_field', value: myDataToUpdate })
        changeEmployeeParams({ 'task_board_custom_field': myDataToUpdate })
        setOpened(null)
        onSubmit?.(result, {})
    }, [setOpened, data, onSubmit])
    return { setOpened, data, setData, changeChecked, changeOrder, beforeSubmit }
}

export default ModalTaskCFieldsFlow